export default __webpack_public_path__ + "static/media/Welcome-gif-M-2B.23093cf7.png";